import { CMSAllocation } from "@components/V2/Vault/Common/VaultAprReports";
import { ReactNode, createContext } from "react";

interface IData {
  cmsAllocations: {
    allocations: CMSAllocation[];
  } | null;
}

const initialData: IData = {
  cmsAllocations: null,
};

export const YieldVaultPageContext = createContext(initialData);

interface IProps {
  children: ReactNode;
  data: IData;
}

export const YieldVaultProider = ({ data, children }: IProps) => {
  return (
    <YieldVaultPageContext.Provider value={data}>
      {children}
    </YieldVaultPageContext.Provider>
  );
};

export { type IData as PageContextData };
